// ============================================
// APP CONFIGURATION
// ============================================

const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1';
// Extract base URL for uploads (remove /api/v1 suffix)
const uploadsBaseUrl = apiUrl.replace(/\/api\/v\d+$/, '');

export const config = {
  appName: 'Crew At Sea',
  appDescription: 'Şirket Paneli',
  apiUrl,
  uploadsBaseUrl,
  
  // Pagination
  defaultPageSize: 10,
  pageSizeOptions: [10, 20, 50, 100],
  
  // File upload
  maxFileSize: 10 * 1024 * 1024, // 10MB
  allowedImageTypes: ['image/jpeg', 'image/png', 'image/webp'],
  allowedDocumentTypes: ['application/pdf', 'image/jpeg', 'image/png'],
  
  // Date formats
  dateFormat: 'dd MMM yyyy',
  dateTimeFormat: 'dd MMM yyyy HH:mm',
};

export const routes = {
  home: '/',
  login: '/login',
  dashboard: '/',
  jobs: '/jobs',
  jobCreate: '/jobs/create',
  jobEdit: (id: string) => `/jobs/${id}/edit`,
  jobDetail: (id: string) => `/jobs/${id}`,
  applications: '/applications',
  applicationDetail: (id: string) => `/applications/${id}`,
  candidates: '/candidates',
  candidateDetail: (id: string) => `/candidates/${id}`,
  reviews: '/reviews',
  profile: '/profile',
  settings: '/settings',
};
